export default __webpack_public_path__ + "static/media/deauville16.a5ffc4bd.jpg";